export default "__VITE_ASSET__D315cx1U__"